import { EnquiryForm } from "@/components/EnquiryForm";

export default function Contact() {
  return (
    <div className="pt-20 lg:pt-24" data-testid="contact-page">
      <EnquiryForm />
    </div>
  );
}
